<template>
  <div class="events-swiper" v-if="eventsArticleArr.length > 0">
    <swiper v-if="isPc" :options="isPc ? swiperOption5 : swiperOption7" ref="mySwiper">
      <swiper-slide v-for="(item, idx) in eventsArticleArr" :key="idx">
        <div class="little_hand" @click="fnToArticle(item.article_id)">
          <div class="events-swiper-item hand" style="width: 100%">
            <img :src="item.main_image[0]" />
            <h3>{{ item.title }}</h3>
          </div>
          <div class="time">
            <div class="circle"></div>
            <time>{{ $dayjs(item.publish_time).format("YYYY-MM-DD") }}</time>
            <div class="line"></div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="bg">
      <img :src="eventsArticleArr[currentIndex].main_image[0]" />
    </div>
    <div></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    id: {
      type: String,
      default: true,
    },
  },
  data() {
    return {
      eventsArticleArr: [],
      currentIndex: 0, // 记录当前滚动的索引
      swiperOption5: {
        slidesPerView: 3.3, //一页显示几个
        spaceBetween: 10,
        loop: false,
        speed: 500,
        autoplay: false,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        navigation: {
          nextEl: ".swiper-button-next5", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev5", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled5", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden5", //按钮隐藏时的Class
        },
        on: {
          slideChangeTransitionEnd: () => {
            // console.log(this.swiper.activeIndex); // 输出当前滚动的索引值
            this.currentIndex = this.swiper.activeIndex;
          },
        },
      },
      swiperOption7: {
        slidesPerView: 1.2, //一页显示几个
        spaceBetween: 16,
        loop: false,
        speed: 500,
        autoplay: false,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        navigation: {
          nextEl: ".swiper-button-next5", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev5", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled5", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden5", //按钮隐藏时的Class
        },
        on: {
          slideChangeTransitionEnd: () => {
            console.log(this.swiper.activeIndex); // 输出当前滚动的索引值
            this.currentIndex = this.swiper.activeIndex;
          },
        },
      },
    };
  },
  computed: {
    ...mapState(["rowMenuList", "isPc"]),
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    if (this.id) {
      this.getEventsArticles(this.id);
    }
  },
  methods: {
    // 获取大事记列表新闻
    async getEventsArticles(id) {
      const { data: res } = await this.$http.get(
        `/api/v2/article/timeMemoryItemList/${id}`
      );
      console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.eventsArticleArr = res.data.map((item) => {
        item.main_image = JSON.parse(item.main_image);
        item.main_image = item.main_image.map((img) =>
          !/^http/.test(img) ? this.$imgUrl + img : img
        );
        return item;
      });
    },
    fnToArticle(article_id) {
      // // console.log(article_id)
      this.$router.push({
        path: `/article/${article_id}`,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.events-swiper {
  margin-top: 20px;
  .bg {
    position: absolute;
    right: 0;
    top: 0;
    img {
      width: auto;
      height: 100%;
      opacity: .2;
      object-fit: cover;
    }

    height: 100%;
  }
  .bg::before {
    position: absolute;
    right: 0;
    top: 0;
    content: "";
    display: inline-block;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      270deg,
      rgba(44, 45, 51, 0) 19%,
      #2c2d33 97%
    );
  }
  .events-swiper-item {
    width: 100%;
    height: 200px;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    h3 {
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 15px;
      width: 100%;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 400;
      opacity: 0.7;
      background: rgba(0, 0, 0, 0.7);
      box-sizing: border-box;
      // border-radius: 0px 0px 4px 4px;
    }
  }
  .time {
    display: flex;
    align-items: center;
    margin-top: 10px;
    .circle {
      width: 6px;
      height: 6px;
      border: 3px solid rgba(255, 255, 255, 1);
      border-radius: 12px;
    }
    time {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: justify;
      line-height: 20px;
      font-weight: 400;
      margin-left: 5px;
      margin-right: 10px;
    }
    .line {
      flex: 1;
      border-top: 2px dashed rgba(255, 255, 255, 0.24);
    }
  }
}
@media screen and (max-width: 768px) {
  .events-swiper {
    margin-top: 16px;
    .bg {
      position: absolute;
      right: 0;
      top: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        opacity: 1;
      }

      height: 100%;
    }
    .bg::before {
      position: absolute;
      right: 0;
      top: 0;
      content: "";
      display: inline-block;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(
        270deg,
        rgba(44, 45, 51, 0) 19%,
        #2c2d33 97%
      );
    }
    .events-swiper-item {
      width: 100%;
      height: 160px;
      border-radius: 4px;
      position: relative;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      h3 {
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 12px;
        width: 100%;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 400;
        opacity: 0.7;
        background: rgba(0, 0, 0, 0.7);
        box-sizing: border-box;
        // border-radius: 0px 0px 4px 4px;
      }
    }
    .time {
      display: flex;
      align-items: center;
      margin-top: 10px;
      .circle {
        width: 6px;
        height: 6px;
        border: 3px solid rgba(255, 255, 255, 1);
        border-radius: 12px;
      }
      time {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: justify;
        line-height: 20px;
        font-weight: 400;
        margin-left: 5px;
        margin-right: 10px;
      }
      .line {
        flex: 1;
        border-top: 2px dashed rgba(255, 255, 255, 0.24);
      }
    }
  }
}
</style>